import React from "react";
import { connect } from "react-redux";
import { object, string } from "prop-types";
import { get } from "lodash";

import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import CardImage from "../../atoms/cardimage";
import { Standard337x280Container } from "../../rows/ad-free";
import translate from "../../translate";

import "./singleStoryWithAd.m.css";

const SingleStoryWithAd = ({ collection, publisherName }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const stories = collection.items.filter((item) => item.type === "story").map((item) => item.story);
  if (!stories.length) {
    return null;
  }

  const [firstStory] = stories;

  return (
    <div styleName="wrapper" className="container" id="share-now">
      <div styleName="content">
        <Link href={firstStory.url}>
          <CardImage
            story={firstStory}
            aspectRatio={[16, 9]}
            imageType="image16x9"
            widths={[430]}
            eager={true}
            showHeadline={false}
            showStoryTypeIcon
          />
        </Link>

        <Link styleName="headline-link" href={firstStory.url}>
          <Headline
            slug={firstStory.url}
            text={firstStory.headline}
            headerType={4}
            headerLevel={4}
            story={firstStory}
          />
        </Link>

        <div styleName="middle-row">
          <div styleName="hr-line">&nbsp;</div>
          <div styleName="share-now">{translate(publisherName, "share_now")}</div>
        </div>
      </div>
      <div styleName="ad">
        <Standard337x280Container id="rightATF" />
      </div>
      uu{" "}
    </div>
  );
};

SingleStoryWithAd.propTypes = {
  collection: object.isRequired,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(SingleStoryWithAd);
